import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { FormControl, FormGroup } from '@angular/forms';
import { falseIfMissing } from 'protractor/built/util';
import { LocalUserService } from '../../shared/services/localUser';
import { Router, ActivatedRoute } from '@angular/router';
import { HeaderTitleService } from 'app/services/header-title.service';
import { CognitoUtil } from 'app/main/shared/services/cognito.service';

@Component({
    selector: 'dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

    alertBadge: number;
    // these are the user dashboards. change at will.
    tabs = {
        user: [
            {
                title: 'Cases',
                section: 'caseList',
                value: 'your'
            },
            {
                title: 'File Petition',
                section: 'newPetition',
                value: null
            },
            {
                title: 'Alerts',
                section: 'alerts',
                value: null
            }
        ],
        org: [
            {
                title: 'Review',
                section: 'caseList',
                value: 'review'
            },
            // {
            //     title: 'New',
            //     section: 'caseList',
            //     value: 'open'
            // },
            {
                title: 'Activities',
                section: 'recentActivity',
                value: null
            },
            {
                title: 'Alerts',
                section: 'alerts',
                value: null
            }
        ],
        orgClerk: [
            {
                title: 'Review',
                section: 'caseList',
                value: 'review'
            },
            {
                title: 'New',
                section: 'caseList',
                value: 'open'
            },
            {
                title: 'Activities',
                section: 'recentActivity',
                value: null
            },
            {
                title: 'Alerts',
                section: 'alerts',
                value: null
            },
            // {
            //     title: 'File Petition',
            //     section: 'newPetition',
            //     value: null
            // },

        ],
        GUARDIAN_USER: [
            {
                title: 'Cases',
                section: 'caseList',
                value: 'your'
            },
            {
                title: 'Alerts',
                section: 'alerts',
                value: null
            }
        ]
    };
    role: string
    userId: string
    userDetails: any
    userRole = null;
    checkrId: number = null
    dialogRef: any
    userTabs = [];

    constructor(
        public dialog: MatDialog,
        private localUser: LocalUserService,
        private router: Router,
        private route: ActivatedRoute,
        private cognito: CognitoUtil,
        private headerService: HeaderTitleService
    ) {

        this.userRole = this.localUser.getRole();
        this.role = this.localUser.getRole();
        this.userId = this.localUser.getUserId();
        this.userDetails = this.localUser.getUser()

        switch (this.userRole) {
            case 'JUDGE':
                this.userTabs = this.tabs.org;
                break;
            case 'CLERK':
                this.userTabs = this.tabs.orgClerk;
                break;
            case 'ATTORNEY':
                this.userTabs = this.tabs.user;
                break;
            case 'GUARDIAN':
                this.userTabs = this.tabs.GUARDIAN_USER;
                break;
            case 'GUARDIANADLITEM':
                this.userTabs = this.tabs.GUARDIAN_USER;
                break;

            default:
                this.userTabs = this.tabs.user;
                break;
        }


    }

    ngOnInit() {
      setTimeout(() => { this.sendHeaders(); });
    }
    sendHeaders(): void {
        this.headerService.sendHeader('dashboard', 'Dashboard')
    }


    submitDetails() {
        if (this.userDetails.background_status === 'new') {
            this.router.navigate(['cases', 'form', 'checkrDetails'])
        }
        if (this.userDetails.background_status === 'pending') {
            this.router.navigate(['settings'])
        }
    }

    getAlertListLength(event) {
        this.alertBadge = event
    }

}



// WEBPACK FOOTER //
// ./src/app/main/content/dashboard/dashboard.component.ts